import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enLang from "./en/trans.json"
import thLang from "./th/trans.json"

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {translation: enLang},
      th: {translation: thLang}
    },
    fallbackLng: "th",
    lng: 'th',
    debug: true,
    // ns: ["translations"],
    // defaultNS: "translations",

    // keySeparator: false,

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
